<!-- Generate Custom Enumeration Form -->
@if (generateCustomEnumerationTypeForm) {
  <medsurf-design-form-control-form
    [formGroup]="generateCustomEnumerationTypeForm"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column align-items-start mb-4">
      <label id="generate_custom_enumeration_label"
             class="mb-2"
             for="generate_custom_enumeration_type">
        {{ 'global.custom_enumeration' | translate }}
      </label>
      <div medsurf-design-content-input-group>
        <!-- Custom Enumeration Type -->
        <medsurf-design-form-control-input-dropdown [formField]="false"
                                                    [control]="generateCustomEnumerationTypeForm.controls.type"
                                                    [options]="FlatModels.QuestionEntityModels.NumberingTypeArray"
                                                    [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"></medsurf-design-form-control-input-dropdown>
        <!-- Generate Custom Enumeration -->
        <button medsurf-design-input-button
                id="generate_custom_enumeration_button"
                [label]="'global.custom_enumeration_generate' | translate"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SORT_A_Z"
                (click)="onSubmit()"></button>
      </div>
    </div>
  </medsurf-design-form-control-form>
}
